import React, { useState } from 'react';

const CustomSlider = ({ 
  id, 
  value, 
  min, 
  max, 
  levels, 
  tooltips, 
  title, 
  description, 
  onChange,
  disabled = false,
  disabledExplanation = null
}) => {
  const [showTooltip, setShowTooltip] = useState(null);
  
  // Função que garante que o evento seja tratado tanto no onChange quanto no onInput
  const handleSliderChange = (e) => {
    // Verificação de segurança para evitar erros quando e.target é null
    if (!e || !e.target) {
      console.warn('Event target is null in CustomSlider handleSliderChange');
      return;
    }
    onChange(e);
  };

  return (
    <div className={`form-group ${disabled ? 'disabled' : ''}`}>
      <label htmlFor={id} className="slider-title">{title}</label>
      <div className="slider-description">{description}</div>
      
      <div className="custom-slider-container">
        <input
          type="range"
          id={id}
          min={min}
          max={max}
          value={value}
          onChange={disabled ? undefined : handleSliderChange}
          onInput={disabled ? undefined : handleSliderChange}
          disabled={disabled}
          className={`custom-slider ${disabled ? 'disabled' : ''}`}
        />
        
        <div className="slider-labels">
          {Object.entries(levels).map(([level, label]) => {
            const position = ((parseInt(level) - min) / (max - min)) * 100;
            const levelNum = parseInt(level);
            
            // Determinar alinhamento baseado na posição
            let alignment = 'center';
            let adjustedPosition = position;
            
            if (levelNum === min) {
              // Primeiro item - alinhado à esquerda
              alignment = 'left';
              adjustedPosition = 0;
            } else if (levelNum === max) {
              // Último item - alinhado à direita
              alignment = 'right';
              adjustedPosition = 100;
            } else {
              // Item do meio - centralizado
              alignment = 'center';
              adjustedPosition = position;
            }
            
            return (
              <div 
                key={level}
                className={`slider-label slider-label-${alignment} ${parseInt(level) === value ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
                style={{ left: `${adjustedPosition}%` }}
              >
                <div className="label-row">
                  <span 
                    className={`label-text ${disabled ? '' : 'clickable'}`}
                    onClick={disabled ? undefined : () => {
                      // Criar evento sintético seguro
                      const syntheticEvent = {
                        target: { 
                          value: levelNum,
                          type: 'range',
                          id: id
                        },
                        preventDefault: () => {},
                        stopPropagation: () => {}
                      };
                      onChange(syntheticEvent);
                    }}
                  >
                    {label}
                  </span>
                  <span 
                    className="tooltip-trigger"
                    onMouseEnter={() => setShowTooltip(level)}
                    onMouseLeave={() => setShowTooltip(null)}
                  >
                    ?
                  </span>
                </div>
                {showTooltip === level && (
                  <div className="tooltip-content">
                    {tooltips[level]}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      
      {disabled && disabledExplanation && (
        <div className="disabled-explanation">
          {disabledExplanation}
        </div>
      )}
    </div>
  );
};

export default CustomSlider;